import React, { Fragment, useEffect, useState } from "react";
import {
  Grid,
  Box,
  MenuItem,
  Menu,
  Avatar,
  Typography,
  Divider,
  Button,
  AppBar,
  Toolbar,
  Badge,
  IconButton,
  Dialog,
  DialogContent,
  Slide,
  DialogTitle
} from "@mui/material";
import {
  CircleNotifications,
  SettingsOutlined,
  LockReset,
  Close,
  VerifiedUser,
  CreditCard,
  CreditCardOff,
  CurrencyExchange,
  ReceiptLong
} from "@mui/icons-material";
import Colors from "../Assets/Styles/Colors";
import { useNavigate } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import { PrimaryButton } from "../Components/Buttons";
import useAuth from "../hooks/useAuth";
import AuthServices from "../Api/Auth/AuthServices";
import PaymentServices from "../Api/Payment/PaymentServices";
import SimpleDialog from "../Components/Dialogs/SimpleDialog";
import Logo from "../Assets/Images/favicon-150x150.png"
import { InputField } from "../Components/Fields/TextFields";
import { useForm } from "react-hook-form";
import { SuccessToaster } from "../Components/Toaster/Toaster";

//* badge style For Notification
const StyledBadge = styled(Badge)(() => ({
  "& .MuiBadge-badge": {
    right: 18,
    top: 6,
    border: `1px solid ${Colors.white}`,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const PaymentStatusDialog = ({ open, onClose, status, onClick, getPaymentMethodStatus }) => {
  useEffect(() => {
    getPaymentMethodStatus();
  }, [status])
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>{"Payment Method"}</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px"
        }}
      >
        <Typography>Do you want to {status ? "disable" : "enable"} payment method?</Typography>
        <Box sx={{ display: "flex", gap: "16px" }}>
          <Button variant={"contained"} onClick={() => onClick()}>{status ? "Disable" : "Enable"}</Button>
          <Button variant={"outlined"} onClick={() => onClose()}>Cancel</Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

const Header = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPlatformDialogOpen, setIsPlatformDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();
  const { userLogout, mail } = useAuth();
  const { register, handleSubmit, setValue } = useForm();

  const openMenu = Boolean(anchorEl);

  const handlePlatformDialog = () => setIsPlatformDialogOpen((open) => !open);

  const getPaymentMethodStatus = async () => {
    try {
      const result = await PaymentServices.getPaymentMethodStatus();
      if (result?.responseCode == 200) {
        setStatus(result?.data?.isMandatory);
        setOpen(false)
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getPlatformFee = async () => {
    try {
      const result = await AuthServices.getPlatformFee();
      if (result?.responseCode == 200) {
        setValue("fee", result?.data?.fee?.fee);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updatePaymentMethodStatus = async () => {
    const obj = {
      isMandatory: !status
    }
    try {
      const result = await PaymentServices.updatePaymentMethodStatus(obj);
      if (result?.responseCode == 200) {
        setStatus(result?.data?.isMandatory);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updatePlatformFee = async (formData) => {
    setLoading(true);
    const obj = {
      fee: formData.fee
    }
    try {
      const result = await AuthServices.updatePlatformFee(obj);
      if (result?.responseCode == 200) {
        SuccessToaster(result.message);
        handlePlatformDialog();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      getPlatformFee();
    }
  };

  useEffect(() => {
    getPaymentMethodStatus();
    getPlatformFee();
  }, [])

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const logout = async () => {
    await userLogout();
    navigate("/login");
  };

  return (
    <Fragment>
      <PaymentStatusDialog
        open={open}
        onClose={() => setOpen(false)}
        status={status}
        onClick={updatePaymentMethodStatus}
        getPaymentMethodStatus={getPaymentMethodStatus}
      />
      <SimpleDialog
        open={isPlatformDialogOpen}
        onClose={handlePlatformDialog}
        title={"Change Platform Fee"}
      >
        <Grid
          container
          spacing={2}
          component={"form"}
          onSubmit={handleSubmit(updatePlatformFee)}
        >
          <Grid item md={12}>
            <InputField
              label={"Platform Fee"}
              register={register("fee")}
            />
          </Grid>
          <Grid item md={12}>
            <PrimaryButton
              disabled={loading}
              loading={loading}
              fullWidth={true}
              title={"Submit"}
              type={"submit"}
            />
          </Grid>
        </Grid>
      </SimpleDialog>
      <AppBar sx={{ mb: 20, bgcolor: Colors.white, boxShadow: 0 }}>
        <Toolbar>
          <Grid container py={2} px={3} justifyContent={"space-between"}>
            <Grid item xs={3}></Grid>
            <Grid item xs={9}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "12px"
                }}
              >
                <Box
                  sx={{
                    backgroundColor: Colors.primary,
                    borderRadius: "50%",
                  }}
                >
                  <IconButton onClick={() => setOpen(true)}>
                    {status
                      ? <CreditCard sx={{ color: Colors.white }} />
                      : <CreditCardOff sx={{ color: Colors.white }} />
                    }
                  </IconButton>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    float: "right",
                    gap: "10px",
                  }}
                  onClick={(e) => {
                    handleClick(e);
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      p: 1,
                      borderRadius: "22px",
                      backgroundColor: Colors.primary,
                      "&:hover": {
                        backgroundColor: Colors.primary,
                        cursor: "pointer",
                        ".MuiSvgIcon-root": { color: Colors.cloud },
                      },
                    }}
                  >
                    <Avatar
                      alt="Admin"
                      sx={{ width: 24, height: 24 }}
                    />
                    <SettingsOutlined
                      sx={{
                        color: Colors.white,
                        fontSize: "26px",
                        ml: 2,
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Menu
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleClose}
            onClick={handleClose}
            id="account-menu"
            PaperProps={{
              elevation: 0,
              sx: {
                width: "350px",
                px: 2,
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": { width: 60, height: 60, ml: 1, mr: 1 },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 500,
                color: Colors.black,
                p: 1.5,
              }}
            >
              User Profile
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                "&:hover": { bgcolor: Colors.lightGray, borderRadius: "10px" },
              }}
            >
              <Avatar
                src={Logo}
                sx={{ borderRadius: "50px" }}
              />
              <Box>
                <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
                  {mail}
                </Typography>
              </Box>
            </Box>
            <Divider sx={{ my: 1 }} />
            <MenuItem
              sx={{ p: 1, borderRadius: "8px" }}
            >
              <Box sx={{ display: "flex" }}>
                <LockReset sx={{ mx: 2, fontSize: "24px" }} />
                <Box>
                  <Typography sx={{ fontSize: "1rem" }}>
                    {" "}
                    Change Password
                  </Typography>
                </Box>
              </Box>
            </MenuItem>
            <Divider sx={{ my: 1 }} />
            <MenuItem
              sx={{ p: 1, borderRadius: "8px" }}
              onClick={handlePlatformDialog}
            >
              <Box sx={{ display: "flex" }}>
                <CurrencyExchange sx={{ mx: 2, fontSize: "20px" }} />
                <Box>
                  <Typography sx={{ fontSize: "1rem" }}>
                    {" "}
                    Change Platform Fee
                  </Typography>
                </Box>
              </Box>
            </MenuItem>
            <Divider sx={{ my: 1 }} />
            <MenuItem
              sx={{ p: 1, borderRadius: "8px" }}
              onClick={() => navigate("/transaction-history")}
            >
              <Box sx={{ display: "flex" }}>
                <ReceiptLong sx={{ mx: 2, fontSize: "20px" }} />
                <Box>
                  <Typography sx={{ fontSize: "1rem" }}>
                    {" "}
                    See Transaction History
                  </Typography>
                </Box>
              </Box>
            </MenuItem>
            <Box sx={{ my: 1.5 }}>
              <PrimaryButton
                data-testId="logout-btn"
                title="logout"
                onClick={logout}
                fullWidth={true}
              />
            </Box>
          </Menu>
        </Toolbar>
      </AppBar>
    </Fragment>
  );
};

export default Header;
